import { create } from 'zustand'

interface User {
  uid: string; username: string; email: string
  display_name?: string; avatar_url?: string
  tier: string; phone?: string
}

interface AuthState {
  user: User | null
  checking: boolean
  setUser: (user: User | null) => void
  checkSession: () => Promise<void>
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  checking: true,

  setUser: (user) => set({ user, checking: false }),

  checkSession: async () => {
    const token = localStorage.getItem('zumo_token')
    if (!token) { set({ user: null, checking: false }); return }
    try {
      const res = await fetch('https://zumo-api.megan.qzz.io/v1/auth/verify', {
        method: 'POST', headers: { Authorization: `Bearer ${token}` },
      })
      const data = await res.json()
      if (data.valid && data.user) set({ user: data.user, checking: false })
      else { localStorage.removeItem('zumo_token'); set({ user: null, checking: false }) }
    } catch { set({ user: null, checking: false }) }
  },

  logout: () => {
    const token = localStorage.getItem('zumo_token')
    if (token) fetch('https://zumo-api.megan.qzz.io/v1/auth/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` } }).catch(() => {})
    localStorage.removeItem('zumo_token')
    set({ user: null })
  },
}))
